export interface ILink {
  data: [Node, Node];
  direction: 'left' | 'right' | 'both';
  color: string | string[];
}

export interface Node {
  id: number;
  name: string;
  x: number;
  y: number;
}

export type IMoveableNode = (x: number, y: number) => Node;

function moveableNodeFactory(id: number, name: string): IMoveableNode {
  return (x = 0, y = 0) => ({
    id,
    name,
    x,
    y,
  });
}

export const NODES: { [key: string]: IMoveableNode } = {
  PLATFORM: moveableNodeFactory(1, 'TreeGraph.Platform'),
  POWER_GRID: moveableNodeFactory(2, 'TreeGraph.PowerGrid'),
  STATION: moveableNodeFactory(3, 'Common.ChargingStation'),
  DISTRIBUTOR: moveableNodeFactory(4, 'TreeGraph.Distributor'),
  PILE: moveableNodeFactory(5, 'TreeGraph.Pile'),
  EV: moveableNodeFactory(6, 'TreeGraph.Ev'),
  MEMBER: moveableNodeFactory(7, 'TreeGraph.Member'),
};
